import { render, staticRenderFns } from "./paketKampanyasi.vue?vue&type=template&id=e8a4b48c&scoped=true&"
import script from "./paketKampanyasi.vue?vue&type=script&lang=js&"
export * from "./paketKampanyasi.vue?vue&type=script&lang=js&"
import style0 from "./paketKampanyasi.vue?vue&type=style&index=0&id=e8a4b48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a4b48c",
  null
  
)

export default component.exports